import { Component } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  public appPages = [
    {
      title: 'Personalización del sistema de alarma',
      url: '/personalizacion-alarma',
      icon: 'construct'
    },
    {
      title: 'Programación de los equipos',
      url: '/programacion-equipos',
      icon: 'today'
    },
    {
      title: 'Tabla de consumos',
      url: '/tabla-consumos',
      icon: 'flash'
    },
    {
      title: 'Cableado',
      url: '/cableado',
      icon: 'git-branch'
    },
    {
      title: 'Solución de problemas',
      url: '/solucion-problemas',
      icon: 'hand'
    },
  ];

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }
}
